import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular';
import { Observable, map } from 'rxjs';
import { Location } from '@angular/common';
import { PropertyService } from './service/property.service';
import { OpenFormComponent } from 'src/app/component/open-form/open-form.component';
import { addPropertyFormField } from './forms/addProperty';
import { copyPropertyFormField } from './forms/copyProperty';
import format from 'date-fns/format';
import { JsonEditorComponent, JsonEditorOptions } from 'ang-jsoneditor';

@Component({
	selector: 'app-properties',
	templateUrl: './properties.page.html',
	styleUrls: ['./properties.page.scss'],
})
export class PropertiesPage implements OnInit {
	editorOptions: JsonEditorOptions = new JsonEditorOptions();

	getPropertyList$: Observable<any> = new Observable();
	loaded$: Observable<any> = new Observable();
	courseId: any;
	cohortId: any;
	allCohorts = [];

	constructor(
		private router: Router,
		public popoverController: PopoverController,
		public modalController: ModalController,
		private location: Location,
		private propertyService: PropertyService,
	) {
		const locationPath: Array<string | any> = this.location.path().split('/');
		this.courseId = locationPath[3];
		this.cohortId = locationPath[6];

		this.propertyService.loadPropertyInit(this.cohortId).subscribe();
		this.propertyService.loadPropertyApi(this.cohortId).subscribe();

		// this.propertyService.fetchDropertydata(this.cohortId);

		this.getPropertyList$ = this.propertyService
			.fetchPropertyData(this.cohortId)
			.pipe(
				map((d: any) => {
					if (d.data && d.data.length > 0) {
						return {
							...d,
							data: d.data.map((p: any) => {
								if (p.format === 'Timestamp' && p.value.length > 5) {
									return { ...p, value: new Date(p.value * 1) };
								} else if (p.format === 'Json') {
									return { ...p, value: JSON.parse(p.value) };
								} else {
									return p;
								}
							}),
						};
					} else {
						return d;
					}
				}),
			);

		this.propertyService.getCohortList(this.courseId).subscribe((data: any) => {
			if (data.length) {
				this.allCohorts = data.filter(
					(cohort: any) => cohort.id != this.cohortId,
				);
			}
		});
	}

	ngOnInit() {}
	isCanOpenBox = true;
	createFaq() {}

	onSave(event: any) {
		const propertiesUpdate = event.map((p: any) => {
			if (p.format === 'Timestamp') {
				return {
					propertyId: p.propertyId,
					propertyValue: String(new Date(p.value).getTime()),
					id: p.id,
				};
			} else if (p.format === 'Json') {
				return {
					propertyId: p.propertyId,
					propertyValue: JSON.stringify(p.value),
					id: p.id,
				};
			} else {
				return {
					propertyId: p.propertyId,
					propertyValue: String(p.value),
					id: p.id,
				};
			}
		});

		this.propertyService
			.bulkUpdate(this.cohortId, propertiesUpdate)
			.subscribe();
	}

	async copyPropertyForm() {
		if (this.isCanOpenBox) {
			const modal = await this.popoverController.create({
				component: OpenFormComponent,
				componentProps: {
					formTitle: 'Copy Cohort Properties',
					form: copyPropertyFormField,
					selectOptions: {
						property: this.allCohorts,
					},
					onSubmitForm: this.copyCohortProperties,
					ref: this,
				},
			});
			modal.style.cssText = `--max-width: 540px;--min-width: 540px;--min-height: 500px`;
			await modal.present();
			await modal.onDidDismiss();
			this.isCanOpenBox = true;
		}
	}

	copyCohortProperties(ref: any, form: any) {
		return ref.propertyService.copyProperty(ref.cohortId, form.property);
	}
}
